'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = undefined;

var _objAsArray = require('shared/utils/objAsArray');

var _objAsArray2 = _interopRequireDefault(_objAsArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//const getSlug = path => {
//return path.split('/').pop();
//};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var data = _ref.data,
      user = _ref.user;
  var job = _ref2.job;
  var educationLevels = data.educationLevels;

  //const job = jobs[getSlug(route)];

  return {
    educationLevels: (0, _objAsArray2.default)(educationLevels),
    job: job.education.required,
    user: user.education
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/RequiredEducation/selectors.js
// module id = 1119
// module chunks = 0